<p-dialog [header]="getTitle()" [(visible)]="showDialog" [modal]="true" [style]="{width: '25vw'}" [baseZIndex]="10000"
  [draggable]="false" [resizable]="false">
  <div class="text-left">
      <div [class]="['text-center',isError?'text-danger':'text-info']"><span>{{msg}}</span></div>
    
    <div class="form-group">
      <label for="exampleInputEmail1">Pincode</label>
      <input type="password" autocomplete="off" class="form-control" id="pincode" name="pincode"
        aria-describedby="confirm pincode" placeholder="" readonly onfocus="if (this.hasAttribute('readonly')) {
            this.removeAttribute('readonly');
            this.blur();    this.focus();  }"  [(ngModel)]="pincode">
    </div>
    <div class="form-group">
      <label for="exampleInputPassword1">Confirm Pincode</label>
      <input type="password" autocomplete="off" class="form-control" id="confirmpincode" name="confirmpincode"
        placeholder="" readonly onfocus="if (this.hasAttribute('readonly')) {
            this.removeAttribute('readonly');
            this.blur();    this.focus();  }"  [(ngModel)]="confirmPincode" (keyup.enter)="savePincode()">
    </div>
    <div>
      <small>6-10 characters, should include at least 1 letter, 1 number and 1 special character.</small><br/>
      <small></small>
    </div>
    <button (click)="savePincode()" [disabled]="validatePincode()" class="btn btn-warning float-right">Update</button>
  </div>
</p-dialog>